export default __webpack_public_path__ + "static/media/doge.5f104009.png";